import React from 'react';

import AddIcon from '@mui/icons-material/Add';
import { Button, Stack, TextField, Typography } from '@mui/material';
import type { GridRenderEditCellParams } from '@mui/x-data-grid';

import { channelMarkupTextReplacementOptions } from '@luxuryescapes/contract-svc-promo/channelMarkup';

type ChannelMarkupFormMarkup = {
  channelMarkupCTAText?: string | null;
};

export default function ChannelMarkupCtaTextEditCell({
  params,
  showDetails,
}: {
  params: GridRenderEditCellParams<ChannelMarkupFormMarkup, string>;
  showDetails: boolean;
}) {
  const currentValue = typeof params.value === 'string' ? params.value : (params.row.channelMarkupCTAText ?? '');

  const appendReplacement = (replacement: string) => {
    const nextValue = `${currentValue}${currentValue && !currentValue.endsWith(' ') ? ' ' : ''}${replacement}`;
    params.api.setEditCellValue({ id: params.id, field: 'channelMarkupCTAText', value: nextValue });
  };

  return (
    <Stack spacing={1}>
      <TextField
        autoFocus
        fullWidth
        value={currentValue}
        onChange={(event) =>
          params.api.setEditCellValue({ id: params.id, field: 'channelMarkupCTAText', value: event.target.value })
        }
        helperText={showDetails ? 'Optional CTA text shown for this markup.' : undefined}
      />
      <Stack spacing={0.75}>
        <Typography variant="caption" color="text.secondary">
          Insert text replacements
        </Typography>
        <Stack direction="row" spacing={1} useFlexGap flexWrap="wrap">
          {channelMarkupTextReplacementOptions.map((option) => (
            <Button
              key={option.name}
              size="small"
              variant="text"
              startIcon={<AddIcon />}
              onClick={() => appendReplacement(option.placeholder)}
            >
              {option.placeholder}
            </Button>
          ))}
        </Stack>
      </Stack>
    </Stack>
  );
}
